/**
 * zeluslugi.ru
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2018 delphinpro
 * @license     licensed under the MIT license
 *
 * @external jQuery
 */

import Vue from 'vue';
import { VPopover } from 'v-tooltip';

import './parts/accodion';
// import './parts/floating-panel';
import './parts/hyphens';
import './parts/nav';
import './parts/action';
import './parts/map-activity';

import { CALC_DISPLAY_AS_FULL, CALC_DISPLAY_AS_MINI } from './calc/calc-constants';
import Calculator from './calc/Calculator.vue';

Vue.component('v-popover', VPopover);

window.isDev = () => localStorage.getItem('development') === '1';

console.log(isDev()
    ? 'Testing mode. LocalStorage key "development" is set "1"'
    : 'Normal mode.');

if (process.env.NODE_ENV !== 'production') {
    let el = document.createElement('div');
    el.innerHTML = 'Режим разработки!!!';
    el.classList.add('dev-warn');
    document.body.appendChild(el);
}

Array.from(document.querySelectorAll('.mini-calc')).forEach(el => {
    let yandexGoal = el.dataset['goal'];
    new Vue({
        el    : el,
        render: createElement => createElement(Calculator, {
            props: {
                displayAs: CALC_DISPLAY_AS_MINI,
                yandexGoal,
            },
        }),
    });
});

Array.from(document.querySelectorAll('.full-calc')).forEach(el => {
    let yandexGoal = el.dataset['goal'];
    new Vue({
        el    : el,
        render: createElement => createElement(Calculator, {
            props: {
                displayAs: CALC_DISPLAY_AS_FULL,
                yandexGoal,
            },
        }),
    });
});
